import { type Static, Type } from "@sinclair/typebox"

export const ValidatorIssueSeveritySchema = Type.Union([
  Type.Literal("error"),
  Type.Literal("warning"),
])

export type ValidatorIssueSeverity = Static<typeof ValidatorIssueSeveritySchema>

export const ValidatorIssueSchema = Type.Object({
  code: Type.String({
    minLength: 1,
  }),
  message: Type.String({
    minLength: 1,
  }),
  path: Type.Optional(Type.String()),
  severity: ValidatorIssueSeveritySchema,
})

export type ValidatorIssue = Static<typeof ValidatorIssueSchema>

export const ValidatorResultSchema = Type.Object({
  valid: Type.Boolean(),
  issues: Type.Array(ValidatorIssueSchema),
})

export type ValidatorResult = Static<typeof ValidatorResultSchema>

// Generic typed result for use in TypeScript code (not a TypeBox schema)
export type TypedValidatorResult<T> = {
  valid: boolean
  value?: T
  issues: ValidatorIssue[]
}
